export default __webpack_public_path__ + "static/media/roughnessActive.389c23df.svg";